<div class="video">
  <div class="video__image-container">
    <iframe
      id="player"
      type="text/html"
      height="300"
      [src]="getYoutubeEmbedUrl() | safe:'resourceUrl'"
      frameborder="0"
      allowfullscreen="allowfullscreen"
      allow="fullscreen;"
      mozallowfullscreen="mozallowfullscreen" 
      msallowfullscreen="msallowfullscreen" 
      oallowfullscreen="oallowfullscreen" 
      webkitallowfullscreen="webkitallowfullscreen"
    >
    </iframe>
  </div>

  <h2 class="video__title desktop-only" [title]="title" (click)="abrirLinkDoYoutube()">{{ limitChars(title, 40) }}</h2>
  <h2 class="video__title mobile-only" (click)="abrirLinkDoYoutube()">{{ title }}</h2>

  <span class="video__date">{{ date }}</span>

  <ui-button (p-click)="compartilharUrlViaWhatsapp()">
    <div class="row">
      <div class="col">
        <i class="fab fa-whatsapp wpp"></i>
      </div>

      <div class="col">
        Compartilhar
      </div>
    </div>
  </ui-button>
</div>